import React from "react";
import styles from "./InfoBox.module.css";

interface InfoBoxProps {
  description?: string;
  steps: string[];
  buttonText: string;
  onButtonClick: () => void;
}

const InfoBox: React.FC<InfoBoxProps> = ({
  description,
  steps,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className={`border d-flex flex-column align-items-center mx-3 ${styles.infoBox}`}>
      {description && <p className={styles.description}>{description}</p>}

      <ul className={styles.stepsList}>
        {steps.map((step, index) => (
          <li key={index} className={styles.stepItem}>
            {/* تشخیص کلمات کلیدی و افزودن کلاس */}
            {step.split(/(Share|Add to home screen|Add)/g).map((word, idx) =>
              ["Share", "Add to home screen", "Add"].includes(word) ? (
                <span key={idx} className={styles.keyword}>{word}</span>
              ) : (
                word
              )
            )}
          </li>
        ))}
      </ul>

      <div className={styles.buttonContainer}>
        <button className={styles.primaryButton} onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default InfoBox;
